<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-align: center;">Jax Moul is a Reiki and crystal healer, intuitive card reader and developing medium. She lives in Cambridgeshire, UK, with her husband, two dogs and two cats.</p><br/>
<p style="text-align: center;">A mother to four grownup children, Jax enjoys walking the dogs through the woods, crochet and spending time with the family and grandchildren.</p><br/>
<p style="text-align: center;">Jax began her spiritual journey in 2018 and soon after began to help clients with Reiki, crystal healing, journaling and card reading. You can find out more at <span style="text-decoration:underline;">WWW.WaterfallsandDragonflies.co.uk</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?6cf3b786